<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="1000px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodawanie zamówień do zlecenia
                </h1>
            </v-card-title>

            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-select
                                v-model="machineId"
                                :items="machines"
                                label="Maszyna"
                                item-value="id"
                                item-text="name"
                                placeholder="Wybierz maszynę..."
                                no-data-text="Brak danych..."
                                hide-details
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-checkbox
                                v-model="hasSeparateImpositions"
                                label="Osobne montaże"
                                hide-details
                                @change="setSeparateImpositions"
                            />
                        </v-col>
                    </v-row>
                </v-container>

                <v-data-table
                    :headers="orderComponentsHeaders"
                    :items="orderComponents"
                    hide-default-footer
                    disable-pagination
                >
                    <template #item.productName="{item}">
                        {{ item.productName }}
                    </template>
                    <template #item.productionNumber="{item}">
                        {{ item.productionNumber }}
                    </template>
                    <template #item.componentName="{item}">
                        {{ item.component.name }}
                    </template>
                    <template #item.impositions="{item}">
                        <v-edit-dialog
                            v-if="!hasSeparateImpositions"
                            :return-value="item.imposition"
                            large
                            lazy
                            persistent
                            cancel-text="Anuluj"
                            save-text="Zapisz"
                        >
                            <div class="d-inline-flex">
                                {{ item.imposition }}
                                <v-icon color="primary" small class="ml-1">
                                    mdi-pencil
                                </v-icon>
                            </div>
                            <template #input>
                                <v-text-field
                                    v-model.number="item.imposition"
                                    label="Montaż"
                                    single-line
                                />
                            </template>
                        </v-edit-dialog>
                        <template v-else>
                            {{ item.imposition }}
                        </template>
                    </template>
                    <template #item.parts="{item}">
                        <v-edit-dialog
                            :return-value="item.parts"
                            lazy
                        >
                            <div class="d-inline-flex">
                                {{ item.parts }}
                                <v-icon color="primary" small class="ml-1">
                                    mdi-pencil
                                </v-icon>
                            </div>
                            <template #input>
                                <v-text-field
                                    v-model.number="item.parts"
                                    label="Ilość użytków"
                                    single-line
                                />
                            </template>
                        </v-edit-dialog>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="createJob"
                >
                    Utwórz szkic zlecenia
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'CreateJobDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        selectedOrderComponents: {
            type: Array,
            default: null
        },
        machines: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            orderComponents: [],
            machineId: null,
            actionLoading: false,
            hasSeparateImpositions: false,
            orderComponentsHeaders: [
                {
                    text: 'Produkt',
                    value: 'productName',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Nr zamówienia',
                    value: 'productionNumber',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Komponent',
                    value: 'componentName',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Montaże',
                    value: 'impositions',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Użytki',
                    value: 'parts',
                    sortable: false,
                    align: 'left',
                },
            ]
        }
    },
    watch: {
        machines(value) {
            this.machineId = value[0].id
        },
        selectedOrderComponents(components) {
            const orderComponents = JSON.parse(JSON.stringify(components))

            orderComponents.forEach(item => {
                item.parts = 1
                item.imposition = 1
            })

            this.orderComponents = orderComponents
        }
    },
    methods: {
        setDefaultMachine() {
            this.machineId = this.machines[0].id
        },
        setSeparateImpositions() {
            if (this.hasSeparateImpositions) {
                this.orderComponents.forEach((item, index) => {
                    item.imposition = index + 1
                })
            } else {
                this.orderComponents.forEach(item => item.imposition = 1)
            }
        },
        createJob() {
            const payload = {
                orderComponents: [],
                machineId: this.machineId
            }

            this.actionLoading = true

            this.orderComponents.forEach(item => {
                payload.orderComponents.push({
                    orderComponentId: item.id,
                    parts: item.parts,
                    imposition: item.imposition
                })
            })

            this.$store.dispatch('jobs/createJob', payload)
                .then(response => {
                    this.$router.push({
                        name: 'jobsJob',
                        params: {
                            jobId: response.data.id
                        }
                    })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>